export const modeOfIntegration = [
    {
        name: 'Server to Server',
        value: 's2s',
        checked: false,
    },
    {
        name: 'Redirect with Pay Page',
        value: 'redirectWithPayPage',
        checked: false,
    },
    {
        name: 'Redirect without Pay Page',
        value: 'redirectWithoutPayPage',
        checked: false,
    },
];

export const security = [
    {
        name: 'One way SSL',
        value: 'oneWaySSL',
        checked: false,
    },
    {
        name: 'Two way SSL',
        value: 'twoWaySSL',
        checked: false,
    },
];


export const entityStatus = [
    {
        name: 'Active',
        value: 'ACTIVE',
        checked: false,
    },
    {
        name: 'Inactive',
        value: 'INACTIVE',
        checked: false,
    },
    {
        name : "Blocked",
        value:"BLOCKED",
        checked:false,
    },
    {
        name : "Inactive With Settlement",
        value:"INACTIVE_WITH_SETTLEMENT",
        checked:false
    }
];

export const allowRetry = [
    {
        name: 'Allow Retry',
        value: 'allowRetry',
        checked: false,
    },
];

export const verifiedPayment = [
    {
        name: 'Allow Verified Payment',
        value: 'verifiedPayment',
        checked: false,
    },
];

export const isFcMerchant = [
    {
        name: 'Freecharge Merchant',
        value: 'isFcMerchant',
        checked: false,
    },
];


export const isStaticQREnabled = [
    {
        name: 'Enable Static QR',
        value: 'isStaticQREnabled',
        checked: false,
    },
];

export const allowFPS = [
    {
        name: 'Enable Fraud Prevention',
        value: 'allowFPS',
    },
];

export const isMultiAttemptOnPayLink = [
    {
        name: 'Allow Multiple Attempt on Payment Link',
        value: 'isMultiAttemptOnPayLink',
        checked: false,
    },
];

export const allowOpenMultiPaymentLink = [
    {
        name: 'Allow Opening Payment Link Simultaneously',
        value: 'allowOpenMultiPaymentLink',
        checked: false,
    },
];

export const instantRollback = [
    {
        name: 'Allow Instant Rollback',
        value: 'instantRollback',
    },
];

export const instantRefund = [
    {
        name: 'Allow Instant Refund',
        value: 'instantRefund',
        checked: false,
    },
];

export const isMerchantTatEnabled = [
    {
        name: 'Allow Merchant Transaction TAT',
        value: 'isMerchantTatEnabled',
        checked: false,
    },
];

export const isMandateRegTatEnabled = [
    {
        name: 'Allow Mandate Registration TAT',
        value: 'isMandateRegTatEnabled',
        checked: false,
    },
];

export const isEncryptionEnabled = [
    {
        name: 'Enable Encryption',
        value: 'isEncryptionEnabled',
        checked: false,
    },
];
export const isDomainWhitelisted = [
    {
        name: 'Enable Domains',
        value: 'isDomainWhitelisted',
        checked: false,
    },
];

export const refundRetry = [
    {
        name: 'Allow Refund Retry',
        value: 'refundRetry',
        checked: false
    },
];
export const refundQueue = [
    {
        name: 'Refund Queue',
        value: 'refundQueue',
        checked: false,
    }
];

export const sftpReport = [
    {
        name: 'Reports via SFTP',
        value: 'isSftpRequired',
        checked: false,
    },
];

// parameter used for 3Ds collect from browser
export const threeDimensionSecurityBrowserInfoCollect = [
    {
        name: 'Enable 3DS Information Collect',
        value: 'threeDimensionSecurityBrowserInfoCollect',
    },
];

export const merchantTxnLimit = [
    {
        name: 'Enable Merchant Transaction Limit',
        value: 'isMerTxnLimitEnabled',
        checked: false,
    },
];

// parameter used for 3Ds collect without browser
export const threeDimensionSecurityInfoHardCoded = [
    {
        name: 'Enable 3DS Information Hardcoded',
        value: 'threeDimensionSecurityInfoHardCoded',
    },
];

export const mtrViaEmailRequired = [
    {
        name: 'Send MTR On Mail',
        value: 'isMtrViaEmailRequired',
        checked: false,
    },
];

export const keyMode = [
    {
        name: 'Test Mode',
        value: 'test',
        checked: false,
    },
    {
        name: 'Live Mode',
        value: 'live',
        checked: false,
    },
];

export const getKeyMode = (isEditMode, userLevel) => {
    if (isEditMode || userLevel === 'ADMIN') {
        return keyMode;
    }
    return keyMode.filter(item => item.value !== 'live');
};

export const platform = [
    {
        name: 'Web Integration',
        value: 'webIntegration',
        checked: false,
    },
    {
        name: 'IOS',
        value: 'ios',
        checked: false,
    },
    {
        name: 'Android',
        value: 'android',
        checked: false,
    },
    {
        name: 'Platform Specific Plugin',
        value: 'platformSpecific',
        checked: false,
    },
];
